/* eslint-disable no-shadow */
export enum ProxyServersQueryKeys {
  GetAll = 'proxyServers/getAll',
  ShowPassword = 'proxyServers/showPassword',
  GetOneById = 'proxyServers/getById',
  Create = 'proxyServers/create',
  Edit = 'proxyServers/edit',
  Delete = 'proxyServers/delete',
  Autocomplete = 'proxyServers/autocomplete',
  Breadcrumb = 'proxyServers/breadcrumb',
  GetSupportedOS = 'proxyServers/getSupportedOS',
  CheckAddresses = 'proxyServers/checkAddresses',
  AddAddresses = 'proxyServers/addAddresses',
}

export enum ProxyServerAddressesQueryKeys {
  Autocomplete = 'proxyServerAddresses/autocomplete',
}
